var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "requirements", style: _vm.requirements.getEditorStyle() },
    [
      _vm._l(_vm.logos, function (logo, i) {
        return _c("app-logo", { key: `logo-${i}`, attrs: { logo: logo } })
      }),
      _vm._l(_vm.freeBlocks, function (freeBlock, i) {
        return _c("app-free-block", {
          key: `freeBlock-${i}`,
          attrs: { "free-block": freeBlock, lang: _vm.lang },
        })
      }),
      _c("div", { staticClass: "text" }, [_vm._v(_vm._s(_vm.exampleText))]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }